import { NgIf, NgOptimizedImage } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CardModule } from "src/app/common/components/card/card.module";
import { IconModule } from "src/app/shared/ui/icon/icon.module";
import { LaunchpadMarketplaceBannerProps } from "../../../container/launchpad.interfaces";

@Component({
  selector: "tpm-marketplace-carousel-item",
  templateUrl: "marketplace-carousel-item.component.html",
  styleUrls: ["marketplace-carousel-item.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgOptimizedImage, CardModule, IconModule]
})
export class MarketplaceCarouselItemComponent {
  @Input() public props!: LaunchpadMarketplaceBannerProps;
  @Input() public isMobile!: boolean;
}
